import Entities from './Entities'

export default ({ getSpaces, addSpace, setWriteAccess, removeSpace }) ->
  Entities({
    addEntity: addSpace
    allEntities: Weaver.Project.list
    comparator: (space) -> space.id()
    entityFilter: (value, space) ->
      space.name().toLowerCase().includes(value.toLowerCase()) or
        space.id().toLowerCase().includes(value.toLowerCase())
    sortBy: (project) -> project.name()
    getEntities: getSpaces
    refreshOnFocus: true
    removeEntity: removeSpace
    setWriteAccess: setWriteAccess
    title: 'spaces'
    titleRenderer: (item) ->
      <span data-testid="domain-space-#{ item.name() }">
        { item.name() }
      </span>
  })
